type Item = {
    name: string
    level: number
}
type PathItemProps = {
    parentFolder?: Item
    projectName: string
}

export function PathItem({ parentFolder, projectName }: PathItemProps) {
    if (!projectName) return null
    return (
        <div className="flex items-center gap-1 text-xs text-neutral-500 font-normal leading-4 mt-1">
            <div className="flex items-center gap-1">
                <img src="/svg/note.svg" alt="Project" className="size-4" />
                <p>{projectName}</p>
            </div>

            {parentFolder && (
                <>
                    {parentFolder.level > 1 ? '/ ... /' : '/'}
                    <div className="flex items-center gap-1">
                        <img src="/svg/folder.svg" alt="Project" className="size-4" />

                        <p>{parentFolder.name}</p>
                    </div>
                </>
            )}
        </div>
    )
}
